module.exports = __webpack_public_path__ + "img/advice-8.851712c7.png";